import React, { useContext, useState, useEffect } from 'react'
import { DataContext } from '../../components/Context/Context'
import formatCurrency from '../../components/Util/Util';
import { Link } from 'react-router-dom';
import CartEmpty from '../../components/Cart/CartEmpty/CartEmpty';
import ConfirmModal from '../../components/ConfirmModal/ConfirmModal';
import "./Cart.css"

function Cart() {
    const value = useContext(DataContext);
    const [cart, setCart] = value.cart;
    const increase = value.increase;
    const decrease = value.decrease;
    const removeProduct = value.removeProduct;
    const [total, setTotal] = useState(0);
    
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [productIdtoDel, setProductIdtoDel] = useState('')

    const onOpenConfirmModal = (productId) => {
        console.log(productId)
        setProductIdtoDel(productId)
        setShowConfirmModal(true)
    }

    const deleteProduct = () => {
        console.log('delete product', productIdtoDel);
        removeProduct(productIdtoDel)
        setProductIdtoDel('')
        setShowConfirmModal(false);
    }

    const cancelDeleteProduct = () => {
        console.log('cancel delete product')
        setProductIdtoDel('')
        setShowConfirmModal(false)
    }


    useEffect(() => {
        const getTotal = () => {
            const res = cart.reduce((prev, item) => {
                return prev + (item.price * item.count)
            }, 0)
            setTotal(res)
        }
        getTotal()
    }, [cart]);

    if (cart.length === 0) {
        return (
            <>
                <CartEmpty />
            </>
        )
    }

    return (
        <>

            <ConfirmModal
                onConfirm={deleteProduct}
                onCancel={cancelDeleteProduct}
                show={showConfirmModal}
            />

            <div className="container-fluid bg-sec marginTop ">
                <div className="container-xxl py-5 cart-wrapper p-0 ">
                    <div className="col-12 row  m-0 p-3 p-lg-0">
                        <div className="col-12 col-sm-8 ">
                            {
                                cart.map(product => (
                                    <div className="row style-sec bg-white rounded cart-detail mb-4 me-sm-2 p-4" key={product._id} >
                                        <div className="img-container col-sm-5 col-lg-4 d-flex justify-content-center ">
                                            <img src={product.images[0]} className='img-fluid rounded border ' alt="" />
                                        </div>
                                        <div className="col-sm-7 col-lg-8 box-cart-details text-center">
                                            <div className="pt-4 pt-sm-0 ">
                                                <h6>{product.name}</h6>
                                                <h6 className='py-4 nameProduct '>{product.fullName}</h6>
                                            </div>
                                            <div className="col-12 row justify-content-center p-0 m-0 pb-4">
                                                <div className="amount d-flex justify-content-center align-items-center border border-2 border-warning text-danger p-0 m-0 ">
                                                    <span className="count" onClick={() => increase(product._id)}>+</span>
                                                    <span className='mx-3 '>{product.count}</span>
                                                    <span className="count" onClick={() => decrease(product._id)}>-</span>
                                                </div>
                                            </div>
                                            <h5 className='price-cart'>{formatCurrency(product.price)}</h5>
                                        </div>
                                        <div className="delete-btn h5 col " onClick={() => onOpenConfirmModal(product._id)}><i className="bi bi-x-circle "></i></div>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="col-12 col-sm-4 p-0 m-0">
                            <div className="row style-sec p-0 m-0 bg-white rounded">
                                <div className="total p-0 m-0 p-3">
                                    <div className="d-flex justify-content-between ">
                                        <span> مبلغ کل :  </span>
                                        <span> {formatCurrency(total)} </span>
                                    </div>
                                    <div className="d-flex justify-content-between border-bottom py-4">
                                        <span>  هزینه ارسال و بسته بندی :  </span>
                                        <span> وابسته به آدرس </span>
                                    </div>
                                    <div className="d-flex justify-content-between  py-4 fs-6">
                                        <span>  قابل پرداخت :  </span>
                                        <span> {formatCurrency(total)}</span>
                                    </div>
                                    <Link to='/' className='d-flex justify-content-center'>
                                        <button className="btn  continue-button"><i className="fa fa-lg fa-arrow-circle-left fa-2x text-top ml5"></i>ادامه ثبت سفارش</button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Cart